export const muxAssetURL = {
    video: (pid) => `https://stream.mux.com/${pid}.m3u8`,
    thumbnail: (pid) => `https://image.mux.com/${pid}/thumbnail.jpg`,
    gif: (pid) => `https://image.mux.com/${pid}/animated.gif`,
    storyboard: (pid) => `https://image.mux.com/${pid}/storyboard.json`,
};
export default muxAssetURL;
